import { render, staticRenderFns } from "./MentionMoney.vue?vue&type=template&id=1c7a06e8&scoped=true"
import script from "./MentionMoney.vue?vue&type=script&lang=js"
export * from "./MentionMoney.vue?vue&type=script&lang=js"
import style0 from "./MentionMoney.vue?vue&type=style&index=0&id=1c7a06e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a06e8",
  null
  
)

export default component.exports